<cap-beschreibung-table-wrapper [tableFullWidth]="tableFullWidth">
  <span class="cap-table-wrapper-title" style="font-weight: bold">
    {{ "Sonderrecht" | translate }}
  </span>
  <ng-container class="cap-table-wrapper-content">
    <cap-list-loader [hasRight]="hasRight" [listLoader]="listLoader" [showTotal]="false" [showZeilenSelect]="false">
      <div class="cap-list-loader-content">
        <table class="cap-table-detail">
          <thead>
            <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
          </thead>
          <tbody>
            <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
          </tbody>
        </table>
      </div>
    </cap-list-loader>
    <ng-template #tableHeaders>
      <tr>
        <th style="width: 35%">{{ "Beschreibung" | translate }}</th>
        <th style="width: 50%">{{ "Rechtsgrund" | translate }}</th>
        <th style="width: 12%">{{ "DatumEntstehung" | translate }}</th>
      </tr>
    </ng-template>
    <ng-template #tableRows>
      @for (sonderrecht of listLoader?.items; track sonderrecht) {
        @for (version of sonderrecht.versions; track version; let last = $last) {
          <tr>
            <td [capHistinfo]="version.histInfo">
              {{ version.text }}
            </td>
            <td>
              @if (last) {
                @for (rechtsgrund of sonderrecht.rechtsgruende; track rechtsgrund) {
                  <div>
                    @if (rechtsgrund && rechtsgrund.histInfo) {
                      <span class="mb-0">
                        <cap-rechtsgrund [rechtsgrund]="rechtsgrund"></cap-rechtsgrund>
                      </span>
                    }
                  </div>
                }
              }
            </td>
          </tr>
        }
      }
    </ng-template>
  </ng-container>
</cap-beschreibung-table-wrapper>
